import { useState } from 'react';
import { Form } from 'react-bootstrap';
import CrudFormLayout from '../../../Layout/CrudFormLayout';
import FormLabel from '../../../Text/FormLabel';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import StatusCheck from '../../StatusCheck';
import ReactSelect from '../../../ReactSelect/ReactSelect';
import statusData from '../../../../utils/statusData';

const BookingForm = ({ apiHandler, editData }) => {
    const initialValues = {
        date: new Date(),
        name: editData?.name || '',
        phone: editData?.phone || '',
        email: editData?.email || '',
        tour_id: editData?.tour_id || '',
        status: editData ? editData?.status : 0,
        // status: editData?.status || '',
    };

    const [formValues, setFormValues] = useState(initialValues);

    const handleChange = (name, value) => {
        setFormValues(prevValues => ({ ...prevValues, [name]: value }));
    };

    console.log('formValues', formValues);

    const formHandler = (formValue) => {
        console.log('fomrValue', formValue);
        if (apiHandler) {
            return apiHandler(formValue);
        }

        console.log(formValue);
        return null;
    };

    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            <Form.Group className='mt-3'>
                <FormLabel title='Name' required />

                <ReactInput name='name' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Phone' required />

                <ReactInput name='phone' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Email' />

                <ReactInput name='email' />
            </Form.Group>

            <Form.Group className='mt-3'>
                <FormLabel title='Tour_id' />

                <ReactInput name='tour_id' />
            </Form.Group>

            {/* <Form.Group className='mt-3'>
                <FormLabel title='Status' />

                <ReactInput name='status' />
            </Form.Group> */}
            {/* <ReactSelect
                    name='status'
                    data={statusData}
                    value={statusData.find((item) => item.id === initialValues.status)}
                    // onChange={(selectedValue) => setFieldValue('status', selectedValue)}
                    onChange={(value) => handleChange('status', value)}
                /> */}

            {/* <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
                {({ setFieldValue }) => (
                    <Form.Group className='mt-3'>
                        <FormLabel title='Status' />
                        <ReactSelect
                            name='status'
                            data={statusData}
                            value={statusData.find((item) => item.id === initialValues.status)}
                            onChange={(selectedOption) => setFieldValue('status', selectedOption.value)}
                        />
                    </Form.Group>
                )}
            </CrudFormLayout> */}
            {/* <Form.Group className='mt-3'>
                <FormLabel title='Status' />

                <ReactSelect
                    name='status'
                    data={statusData}
                    // valueName={statusData.id}
                    // labelName={statusData.name}
                    // value={initialValues.status}
                    value={statusData.find((item) => item.id === initialValues.status)}
                    onChange={(value) => handleChange('status', value)}
                />
            </Form.Group> */}

            <StatusCheck />
        </CrudFormLayout>
    );

    return (
        <CrudFormLayout initialValues={initialValues} apiHandler={formHandler}>
            {({ setFieldValue, values }) => (
                <>
                    <Form.Group className='mt-3'>
                        <FormLabel title='Name' required />
                        <ReactInput name='name' />
                    </Form.Group>

                    <Form.Group className='mt-3'>
                        <FormLabel title='Phone' required />
                        <ReactInput name='phone' />
                    </Form.Group>

                    <Form.Group className='mt-3'>
                        <FormLabel title='Email' />
                        <ReactInput name='email' />
                    </Form.Group>

                    <Form.Group className='mt-3'>
                        <FormLabel title='Tour ID' />
                        <ReactInput name='tour_id' />
                    </Form.Group>

                    <Form.Group className='mt-3'>
                        <FormLabel title='Status' />
                        <ReactSelect
                            name='status'
                            data={statusData}
                            value={statusData.find((item) => item.id === values.status)}
                            onChange={(selectedOption) => setFieldValue('status', selectedOption.value)}
                        />
                    </Form.Group>
                </>
            )}
        </CrudFormLayout>
    );
};

export default BookingForm;
